import { inject, observer } from "mobx-react";
import { useState, useEffect, useRef } from "react";

import myImage from "./img/timer_icon.svg";

const min = 5;
const defaultMS = min * 60000;
const intervalDefault = 10;

import "./style.scss";

const Timer = inject("mainStore")(
    observer(({ mainStore }) => {
        const isStart = mainStore.getMainStore("isStart");

        const [timer, setTimer] = useState(defaultMS);
        const intervalRef = useRef(null);

        useEffect(() => {
            if (!isStart) {
                intervalRef.current = setInterval(tick, intervalDefault);
            }
            return () => clearInterval(intervalRef.current);
        }, [isStart]);

        const tick = () => {
            setTimer((prev) => {
                if (prev <= intervalDefault) {
                    clearInterval(intervalRef.current);
                    return 0;
                }
                return prev - intervalDefault;
            });
        };

        const progress = 100 * (1 - timer / defaultMS);
        const totalSeconds = Math.floor(timer / 1000);
        const minutes = String(Math.floor(totalSeconds / 60)).padStart(2, "0");
        const seconds = String(totalSeconds % 60).padStart(2, "0");
        const milliseconds = String(Math.floor((timer % 1000) / 10)).padStart(2, "0");

        return (
            <div className="timer" id="timer">
                <div className="timer__progress" style={{ width: `${progress}%` }}></div>
                <img src={myImage} />У вас осталось{" "}
                <span>
                    <div>{minutes}</div>:<div>{seconds}</div>:<div>{milliseconds}</div>
                </span>
            </div>
        );
    }),
);

export default Timer;
